import { getPps } from 'ACTIONS/categories/getPps';
import { API_URLS } from 'CONFIG/API_URLS';
import { PP_TYPE } from 'MODULES/PP_TYPE';

export const getSubscriptionCategoryLots = (id, flush = false, activePage, filters) => (dispatch) => {
    const location = window.location.pathname;
    return dispatch(getPps(location, API_URLS.CATEGORY_LOTS(id), PP_TYPE.filtersCategory, flush, filters, activePage));
};
